import { render, staticRenderFns } from "./LoginForget.vue?vue&type=template&id=7ae7e4a4&"
import script from "./LoginForget.vue?vue&type=script&lang=js&"
export * from "./LoginForget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports